import { render } from "./saveResult.vue?vue&type=template&id=6e03415c"
import script from "./saveResult.vue?vue&type=script&lang=js"
export * from "./saveResult.vue?vue&type=script&lang=js"

import "./saveResult.vue?vue&type=style&index=0&id=6e03415c&lang=css"
script.render = render

export default script